// src/components/Issues/IssueTable.js
import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  IconButton,
  Skeleton,
  Typography,
  Box,
} from '@mui/material';
import { Sort as SortIcon } from '@mui/icons-material';
import IssueRow from './IssueRow';
import SearchBar from './SearchBar';
// import IssueRow from './IssueRow';
// import SearchBar from './SearchBar';

const IssueTable = ({
  issues,
  loading,
  pagination,
  sort,
  onOpenMenu,
  processingId,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
  canViewListIssue = true
}) => {
  if (!canViewListIssue) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">
          You don't have permission to view issues.
        </Typography>
      </Paper>
    );
  }

  return (
    <>
      <TableContainer component={Paper}>
        <Table aria-label="issues table">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'grey.100' }}>
              <TableCell sx={{ fontWeight: 600 }}>Lead Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Issue Title
                  <IconButton
                    size="small"
                    onClick={() => onSortChange('title')}
                    color={sort.sort_by === 'title' ? 'primary' : 'default'}
                  >
                    <SortIcon />
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Created By</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  Created Date
                  <IconButton
                    size="small"
                    onClick={() => onSortChange('created_at')}
                    color={sort.sort_by === 'created_at' ? 'primary' : 'default'}
                  >
                    <SortIcon />
                  </IconButton>
                </Box>
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(pagination.pageSize)].map((_, i) => (
                <TableRow key={i}>
                  {[...Array(6)].map((_, j) => (
                    <TableCell key={j}><Skeleton height={30} /></TableCell>
                  ))}
                </TableRow>
              ))
            ) : issues.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                  <Typography>No issues available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              issues.map((issue) => (
                <IssueRow
                  key={issue.id}
                  issue={issue}
                  onOpenMenu={onOpenMenu}
                  processingId={processingId}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {!loading && issues.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={pagination.total}
          rowsPerPage={pagination.pageSize}
          page={pagination.page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

// Attach SearchBar as a static property
IssueTable.SearchBar = SearchBar;

export default IssueTable;